import React from "react";
import CmsBlock from "app/layout/cmsBlock";
import { Link, useLocation } from "react-router-dom";

const PortfolioHero = () => {
  const location = useLocation();
  let pathname = location.pathname;

  const links = [
    {
      id: 1,
      url: "/notable-installs",
      name: "notable installs",
    },
    {
      id: 2,
      url: "/portfolio",
      name: "inspirations",
    },
  ];
  return (
    <>
      <div className="banner-wrapper">
        <CmsBlock id={"portfolio-banner"} />
      </div>
      <div className="portfolio-tabs">
        {links.map((link) => (
          <Link style={{ color: "#333" }} to={link.url}>
            <div
              key={link.id}
              className={`portfolio-tab ${
                pathname === link.url ? "clicked" : ""
              }`}
            >
              {link.name}
            </div>
          </Link>
        ))}
      </div>
    </>
  );
};

export default PortfolioHero;
